import { NetWorthSnapshot } from '../types';

const MS_PER_YEAR = 1000 * 60 * 60 * 24 * 365.25;

export type SnapshotWithAge = NetWorthSnapshot & { age: number };

export const getSnapshotsWithAge = (
  snapshots: NetWorthSnapshot[] | undefined,
  currentAge: number
): SnapshotWithAge[] => {
  const now = Date.now();

  return (snapshots || [])
    .map((snapshot) => {
      const snapshotDate = new Date(snapshot.date);
      if (Number.isNaN(snapshotDate.getTime())) return null;

      const yearsAgo = (now - snapshotDate.getTime()) / MS_PER_YEAR;
      const ageAtSnapshot = currentAge - yearsAgo;

      return { ...snapshot, age: ageAtSnapshot };
    })
    .filter((snapshot): snapshot is SnapshotWithAge => snapshot !== null)
    .sort((a, b) => a.age - b.age);
};

export const getJourneyStart = (
  snapshotsWithAge: SnapshotWithAge[],
  fallbackAge: number,
  fallbackNetWorth: number
) => {
  const earliest = snapshotsWithAge[0];

  return earliest
    ? { startAge: earliest.age, startNetWorth: earliest.totalNetWorth }
    : { startAge: fallbackAge, startNetWorth: fallbackNetWorth };
};

export const requiredNetWorthAtAge = ({
  age,
  retirementAge,
  fireTarget,
  currentAge,
  currentNetWorth,
}: {
  age: number;
  retirementAge: number;
  fireTarget: number;
  currentAge: number;
  currentNetWorth: number;
}) => {
  const clampedAge = Math.min(Math.max(age, currentAge), retirementAge);
  const duration = retirementAge - currentAge;

  if (duration <= 0) return fireTarget;

  return (
    currentNetWorth +
    ((fireTarget - currentNetWorth) * (clampedAge - currentAge)) / duration
  );
};
